module.exports = __webpack_public_path__ + "img/mobikwik_long.3fd3380e.svg";